"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubmitButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _basis = require("basis");

var _templateObject;

var Content = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & > svg:first-of-type {\n    margin-right: 8px;\n  }\n"])));

var s = {
  Content: Content
};

var SubmitButton = function SubmitButton(props) {
  var lockIcon = props.lockIcon,
      children = props.children,
      loading = props.loading;
  return /*#__PURE__*/_react.default.createElement(_basis.Button, {
    type: "submit",
    loading: loading
  }, /*#__PURE__*/_react.default.createElement(s.Content, null, lockIcon && /*#__PURE__*/_react.default.createElement(_basis.Icon, {
    name: "lock",
    color: "white",
    testId: "lock-icon"
  }), children));
};

exports.SubmitButton = SubmitButton;